<template>
    <div class="cookie-consent grid grid__base">
        <div class="grid--row">
            <div class="cookie-consent--input-col grid--col">
                <form-field-toggle
                        :id="value"
                        :value="isChecked"
                        :state="{disabled}"
                        :label="label"
                        @input="onChange"
                />
            </div>

            <div class="cookie-consent--text-col grid--col">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    import GenericForm from 'framework/components/form/generic-form/generic-form';
    import FormFieldCheckbox from 'framework/global-components/dyn/form/form-field-checkbox/form-field-checkbox';
    import FormFieldToggle from 'framework/global-components/dyn/form/form-field-toggle/form-field-toggle';

    export default {
        components: { FormFieldToggle, FormFieldCheckbox, GenericForm },
        props: {
            value: {
                type: String,
                required: true,
            },

            label: {
                type: String,
                required: true,
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            initial: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                isChecked: false,
            };
        },

        methods: {
            onChange(data) {
                this.isChecked = data;
            },
        },

        mounted() {
            this.isChecked = this.initial;
        },
    };
</script>
